Ext.define('SA.BalancedChartText', {
    singleton: true,

    get({text, maxWidth, textAnchor, ...styles}) {
        var textWrapper = this.textWrapper = (this.textWrapper || new SA.BalancedTextWrapper()),
            balancedMaxWidth = textWrapper.getWidth({text, maxWidth, styles}),
            style = {maxWidth: `${balancedMaxWidth}px`, ...styles};

        return SA.Svg.wrapText({textAnchor, style, content: text});
    }
});